import CategoryBadge from "../common/CategoryBadge";
import type { Article } from "../../types/article";

type Props = {
    article: Article;
};

export default function NewsCard({ article }: Props) {
    return (
        <article className="overflow-hidden rounded-2xl border border-white/10 bg-[#0d121b] transition hover:translate-y-[-2px] hover:border-[#ff7a00]/30">
            <div className="h-[220px] overflow-hidden">
                <img
                    src={article.image}
                    alt={article.title}
                    className="h-full w-full object-cover transition duration-300 hover:scale-[1.03]"
                />
            </div>

            <div className="space-y-4 p-5">
                <CategoryBadge label={article.category} />

                <div>
                    <p className="mb-2 text-xs font-bold uppercase tracking-[0.18em] text-white/45">
                        {article.publishedAt}
                    </p>

                    <h3 className="text-xl font-black uppercase leading-tight text-white">
                        {article.title}
                    </h3>
                </div>

                <p className="text-sm leading-6 text-white/70">{article.excerpt}</p>

                <button className="text-sm font-black uppercase tracking-wide text-[#e5ff00] transition hover:text-[#ff7a00]">
                    Lire plus
                </button>
            </div>
        </article>
    );
}